import React from "react";

const LeafNode = props => {
  const { attributes, children, leaf } = props;

  const getFormattedChild = () => {
    let formattedChild = children;

    if (leaf?.bold) {
      formattedChild = <strong>{formattedChild}</strong>;
    }
    if (leaf?.italic) {
      formattedChild = <em>{formattedChild}</em>;
    }
    if (leaf?.underlined) {
      formattedChild = <u>{formattedChild}</u>;
    }

    return formattedChild;
  };

  return <span {...attributes}>{getFormattedChild()}</span>;
};

export default LeafNode;
